import React from 'react'
import { Button } from 'react-bootstrap'
import { Form } from 'react-bootstrap'
import { Controller, useForm } from 'react-hook-form'
import LoadingButtonWithForm from '../../../components/LoadingButtonWithForm'
import { useNavigate, useParams } from 'react-router-dom'
import { convertToFormData, sweetAlert } from '../../../utils'
import { useSaveApplicationMutation } from '../../../redux/services/ApplicationService'
import { responseError } from '../../../helpers/responseHandler'

const StepOne = ({ activeStep, setActiveStep, params, isEdit }) => {
  const navigation = useNavigate()

  let {
    control,
    register,
    handleSubmit,
    setValue,
    watch,
    reset,
    formState: { errors },
  } = useForm()

  const [editRequest, { isLoading: editLoading }] = useSaveApplicationMutation()

  const onSubmit = async data => {
    const newForm = convertToFormData({ step_no: '11', ...data })
    await editRequest({ params, newForm })
      .unwrap()
      .then(res => {
        sweetAlert('Form Submit Successfully', 'success')
        setTimeout(() => {
          submitForm()
        }, 1000)
        // navigation("/thankyou");
        // navigation(`/application/view/${params?.systemID}/${params?.driverId}`);
        if (res?.status) {
          sweetAlert(res?.message, 'success')
        }
        // if (res?.errors) {
        //     Object.entries(res?.errors)?.forEach(([key, value]) => {
        //         sweetAlert(value[0], 'error')
        //     })
        // }
      })
      .catch(err => {
        responseError(err)
      })
  }

  const submitForm = () => {
    // navigation("/thankyou");
    navigation(`/application/view/${params?.systemID}/${params?.driverId}`)
  }
  return (
    <>
      <div className='row justify-content-center'>
        <div className='col-xl-10'>
          <div className='card custom-card'>
            <div className='card-body'>
              <h5 className='text-center'>Medical Information (DOT Physical Exam)</h5>

              <div className='row'>
                <Form
                  onSubmit={handleSubmit(onSubmit)}
                  className='col-md-12'
                  id='application-status'
                >
                  <div className='row'>
                    <div className='col-lg-6'>
                      <Form.Group className='mb-3'>
                        <Form.Label>Medical Examiner's Certificate Number (Optional):</Form.Label>
                        <Controller
                          name='medical_examiner_certificate_number'
                          control={control}
                          defaultValue={isEdit?.medical_examiner_certificate_number || ''}
                          rules={{ required: false }}
                          render={({ field }) => (
                            <Form.Control
                              type='text'
                              placeholder="Enter Medical Examiner's Certificate Number"
                              {...field}
                              isInvalid={errors.medical_examiner_certificate_number}
                            />
                          )}
                        />
                      </Form.Group>
                    </div>
                    <div className='col-lg-6'>
                      <Form.Group className='mb-3'>
                        <Form.Label>Medical Examination Date (Optional):</Form.Label>
                        <Controller
                          name='medical_examiner_date'
                          control={control}
                          defaultValue={isEdit?.medical_examiner_date || ''}
                          rules={{ required: false }}
                          render={({ field }) => (
                            <Form.Control
                              type='date'
                              placeholder='Enter Medical Examination Date'
                              {...field}
                              isInvalid={errors.medical_examiner_date}
                            />
                          )}
                        />
                      </Form.Group>
                    </div>
                    <div className='col-lg-6'>
                      <Form.Group className='mb-3'>
                        <Form.Label>Expiration Date of Medical Certificate:</Form.Label>
                        <Controller
                          name='exp_medical_examiner_date'
                          control={control}
                          defaultValue={isEdit?.exp_medical_examiner_date || ''}
                          rules={{ required: true }}
                          render={({ field }) => (
                            <Form.Control
                              type='date'
                              placeholder='Enter Expiration Date of Medical Certificate'
                              {...field}
                              isInvalid={errors.exp_medical_examiner_date}
                            />
                          )}
                        />
                      </Form.Group>
                    </div>
                    <div className='col-lg-6'>
                      <Form.Group className='mb-3'>
                        <Form.Label>Medical Examiner’s Name (Optional):</Form.Label>
                        <Controller
                          name='medical_examiner_name'
                          control={control}
                          defaultValue={isEdit?.medical_examiner_name || ''}
                          rules={{ required: false }}
                          render={({ field }) => (
                            <Form.Control
                              type='text'
                              placeholder='Enter Medical Examiner’s Name'
                              {...field}
                              isInvalid={errors.medical_examiner_name}
                            />
                          )}
                        />
                      </Form.Group>
                    </div>
                    <div className='col-lg-6'>
                      <Form.Group className='mb-3'>
                        <Form.Label>Medical Examiner’s Contact Information (Optional):</Form.Label>
                        <Controller
                          name='medical_examiner_contact'
                          control={control}
                          defaultValue={isEdit?.medical_examiner_contact || ''}
                          rules={{ required: false }}
                          render={({ field }) => (
                            <Form.Control
                              type='text'
                              placeholder='Enter Medical Examiner’s Contact Information'
                              {...field}
                              isInvalid={errors.medical_examiner_contact}
                            />
                          )}
                        />
                      </Form.Group>
                    </div>
                    <div className='col-lg-6'>
                      <Form.Group className='mb-3'>
                        <Form.Label htmlFor='expiration_notification'>
                          Expiration Notification:
                        </Form.Label>
                        <Controller
                          name='expiration_notification'
                          control={control}
                          defaultValue={Boolean(isEdit?.expiration_notification) ? 1 : 0}
                          rules={{ required: true }}
                          render={({ field }) => (
                            <Form.Check
                              type='checkbox'
                              label='Receive reminders'
                              id='expiration_notification'
                              defaultChecked={field.value}
                              onChange={e => field.onChange(e.target.checked ? 1 : 0)}
                              isInvalid={errors.expiration_notification}
                            />
                          )}
                        />
                      </Form.Group>
                    </div>
                    <div className='col-lg-6'>
                      <Form.Group className='mb-3'>
                        <Form.Label>Upload Copy of Medical Examiner's Certificate:</Form.Label>
                        <Controller
                          name='medical_examiner_certificate'
                          control={control}
                          defaultValue={''}
                          rules={{
                            required: isEdit?.medical_examiner_certificate ? false : true,
                            validate: {
                              fileSize: file => {
                                if (!file) return true // allow empty if not required
                                return (
                                  file.size <= 5 * 1024 * 1024 || 'File size must be less than 5MB'
                                )
                              },
                              fileType: file => {
                                if (!file) return true // skip if not required
                                const allowedTypes = ['image/jpeg', 'image/png', 'application/pdf']
                                return (
                                  allowedTypes.includes(file.type) ||
                                  'Only JPEG, PNG, or PDF files are allowed'
                                )
                              },
                            },
                          }}
                          render={({ field }) => (
                            <>
                              <Form.Control
                                type='file'
                                onChange={e => field.onChange(e.target.files[0])}
                                isInvalid={errors.medical_examiner_certificate}
                              />
                              {errors.medical_examiner_certificate && (
                                <Form.Control.Feedback type='invalid'>
                                  {errors.medical_examiner_certificate.message}
                                </Form.Control.Feedback>
                              )}
                            </>
                          )}
                        />
                        {isEdit?.medical_examiner_certificate_url ? (
                          <p>
                            <a
                              href={isEdit?.medical_examiner_certificate_url}
                              target='_blank'
                              className='text-primary my-1'
                            >
                              View Upload File
                            </a>
                          </p>
                        ) : (
                          '-'
                        )}
                      </Form.Group>
                    </div>
                  </div>
                </Form>
                <div className='col-lg-3 d-flex mb-3'>
                  <Button
                    variant='secondary'
                    className='mt-auto w-100'
                    onClick={() => setActiveStep(8)}
                  >
                    Previous
                  </Button>
                </div>
                <div className='col-lg-3 d-flex mb-3'>
                  <LoadingButtonWithForm
                    isLoading={editLoading}
                    name='Submit'
                    form='application-status'
                    className='text-white mt-auto w-100'
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default StepOne
